export default __webpack_public_path__ + "static/media/Dzire.8f398ca8.png";